export const notifications = {
    warning: {
        header: 'Hier scheint ein Fehler aufgetreten zu sein.',
        body: 'Bitte überprüfen Sie ihre Internetverbindung oder versuchen Sie es zu einem späteren Zeitpunkt erneut.',
    },
    repairingFile: {
        header: 'Reparatur notwendig.',
        body: 'Ihr Bauteil ist noch nicht für den 3D-Druck optimiert und wird für Sie automatisch repariert. Bitte haben Sie einen Moment Geduld.',
    },
    technicalDifficulties: {
        header: 'Technische Schwierigkeiten',
        body:
            'Lieber Kunde,\n aufgrund eines Software Updates kann es im Safari-Browser derzeit zu technischen Schwierigkeiten bei dem Upload von 3D-Dateien kommen.\n ' +
            'Wir arbeiten mit Hochdruck an einer Lösung und bitten um Ihr Verständnis.',
    },
    holiday_leave: {
        header: "Wichtige Information",
        body: "Wir befinden uns vom 22.12.2025 - 06.01.2026 in den Betriebsferien.\nAb dem 07.01.2026 sind wir wieder wie gewohnt für Sie da."
    },
    we_are_moving: {
        header: "Wir ziehen um!",
        body: "Aufgrund unseres Umzuges, kann es in der Zeit vom <span style='font-weight: 700;' >07.07.-31.07.2023</span> zu Verzögerungen in der Fertigung kommen.\nWir bemühen uns darum, unsere gewohnten Standardlieferzeiten einzuhalten, können dies aber nicht zu 100% garantieren. Wir danken für Ihr Verständnis."
    },
    new_address_info: {
        header: "Wir sind umgezogen!",
        body: "Ab sofort finden Sie uns unter folgender Adresse:<br /> <span style=' font-weight: 700;' >Holzwiesenstraße 2</span><br /> <span style='font-weight: 700;' >72127 Kusterdingen</span>"
    }
};
